import request from '@/http'
const urlMember = process.env.VUE_APP_LOGINAPI
export const api = {
  // 邀请提交
  InvitedForm: (params) => request.post(urlMember + '/sgb-member/ov1/member/league/memberJoin', params),
  // 申请提交
  saveForm: (params) => request.post(urlMember + '/sgb-member/ov1/member/league/save', params),
  // 搜索企业
  searchEnterprise: (params) => request.get(urlMember + '/memberCenter/userJoinCompanyAudit/searchComList', params),
  // 我的企业
  getUserCompany: () => request.get(urlMember + '/memberCenter/api/user/getMemberUserCompany'),
  // 合作类型
  getServiceTypeList: () => request.get(urlMember + '/memberCenter/v2/api/companyInfo/getServiceTypeList'),
  // 会员类型
  getMemberTypeList: () => request.get(urlMember + '/sgb-member/sysMemberType/getList')

}
